import Slider from "~/components/ui/Slider"
import Icon from "~/components/ui/Icon"

export interface Item {
    /**
     * @title Nome
     */
    label: string

    /**
     * @title Link
     */
    url: string
}

export interface Props {
    /**
     * @title Título
     */
    title: string

    /**
     * @title Itens
     */
    items: Item[]
}

/** Seconds per item for one full pass — slow enough to read */
const SECONDS_PER_ITEM = 6

export default function TopSales({ title, items }: Props) {
    if (!items.length) return null

    // Duplicate for a seamless loop (animation translates -50%)
    const loopItems = [...items, ...items]
    const duration = `${Math.max(items.length * SECONDS_PER_ITEM, 16)}s`

    return (
        <div className='py-2 bg-salmon'>
            <div className='max-w-[1810px] mx-auto grid justify-items-center gap-3 md:px-4 md:grid-cols-[max-content_1fr] md:gap-8'>
                <span className='text-white text-sm font-bold whitespace-nowrap flex items-center gap-1'>
                    <Icon id='StarOutline' size={18} />
                    {title}
                    <Icon id='StarOutline' size={18} />
                </span>

                {/* isolate prende o z-10 dos fades; sem isso eles passam por cima do minicart */}
                <div className='isolate w-full overflow-hidden relative before:w-16 before:h-full before:bg-gradient-to-r before:from-salmon before:to-transparent before:absolute before:top-0 before:left-0 before:z-10 after:w-16 after:h-full after:bg-gradient-to-l after:from-salmon after:to-transparent after:absolute after:top-0 after:right-0 after:z-10'>
                    <Slider
                        className='flex w-max animate-top-sales-marquee hover:[animation-play-state:paused]'
                        style={{ animationDuration: duration }}
                    >
                        {loopItems.map(({ label, url }, index) => {
                            const itemIndex = index % items.length

                            return (
                                <Slider.Item
                                    key={`${itemIndex}-${index}`}
                                    className='shrink-0 px-3 lg:px-12'
                                    index={index}
                                    aria-hidden={index >= items.length ? 'true' : undefined}
                                >
                                    <a
                                        className='text-white text-sm text-center font-bold whitespace-nowrap'
                                        href={url}
                                        tabIndex={index >= items.length ? -1 : undefined}
                                    >
                                        {itemIndex + 1}. {label}
                                    </a>
                                </Slider.Item>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    )
}
